import { Stack, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { AlarmDetails } from '../../api/models'
import { useRouteLocation } from '../../hooks/useRouteLocation'
import { formatIsoTimestampForLocation } from '../../utils/dateUtils'

interface AlarmCardProps {
  alarm: AlarmDetails
}

const PanelItem: FC<{ label: ReactNode; value: ReactNode; testId?: string }> = ({ label, value, testId }) => {
  return (
    <Stack>
      <Typography fontSize="var(--size-s)" fontWeight={500}>
        {label}
      </Typography>
      <Typography fontSize="var(--size-xl)" fontWeight={300} data-testid={testId}>
        {value}
      </Typography>
    </Stack>
  )
}

export const AlarmCard: FC<AlarmCardProps> = ({ alarm }) => {
  const location = useRouteLocation()

  const humanTime = formatIsoTimestampForLocation(alarm.createdTimestamp, location)

  return (
    <Stack direction={'row'} alignItems={'start'} justifyContent={'space-between'} flexGrow={1} gap="var(--spacing-s)" useFlexGap>
      <PanelItem label={'Alarm'} value={alarm.id} />
      <PanelItem label={'Category'} value={alarm.category} />
      <PanelItem label={'Created At'} value={humanTime} testId="alarm-card-created-at" />
    </Stack>
  )
}
